import React, { useEffect, useState, useCallback } from "react";
import { getWithTokenAPI, putAPI } from "../../utils/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CircularProgress,
  Box,
  Typography,
  Avatar,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  IconButton,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ImageList,
  ImageListItem,
  Pagination,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  Science as ScienceIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  LocalOffer as LocalOfferIcon,
  Edit as EditIcon,
  Image as ImageIcon,
  Group as GroupIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { CiLocationOn } from "react-icons/ci";

const SoilTesting = () => {
  const [soilTestsData, setSoilTestsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [selectedSoilTest, setSelectedSoilTest] = useState(null);
  console.log(selectedSoilTest, "selectedSoilTest")
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  console.log(editFormData.croptype)
  const [isUpdating, setIsUpdating] = useState(false);
  const [allAdmins, setAllAdmins] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [soiltestsPerPage] = useState(10);
  const permissions = JSON.stringify(localStorage.getItem("permissions"))

  const primaryGreen = "#DC3545";
  const lightGreen = "#ffe5e5";
  const darkGreen = "#b02a37";
  const secondaryTextColor = "rgba(0, 0, 0, 0.6)";

  const soilTypes = ["sandy", "clay", "loamy", "silty"];
  const cropTypes = ["wheat", "rice", "corn", "vegetables", "fruits"];
  const paymentStatuses = ["Pending", "Completed", "Failed"];
  const bookingStatuses = ["Pending", "Confirmed", "Cancelled", "Completed"];

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  const fetchSoilTests = useCallback(async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const endpoint = "/soil-testing/find-all";
      const res = await getWithTokenAPI(token, endpoint);

      if (res.statusCode === 200) {
        setSoilTestsData(res.data.soil_tests || []);
        setCurrentPage(1);
      } else {
        toast.error(res.message || "Failed to load soil testing records.");
        setSoilTestsData([]);
      }
    } catch (error) {
      console.error("Fetch soil testing error:", error);
      toast.error(
        "Failed to load soil testing records due to a network error."
      );
      setSoilTestsData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const indexOfLastSoilTest = currentPage * soiltestsPerPage;
  const indexOfFirstSoilTest = indexOfLastSoilTest - soiltestsPerPage;
  const currentSoilTests = soilTestsData.slice(
    indexOfFirstSoilTest,
    indexOfLastSoilTest
  );
  const totalPages = Math.ceil(soilTestsData.length / soiltestsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const fetchAdmins = useCallback(async (statusFilter = null) => {
    const token = localStorage.getItem("token");
    try {
      let url = "/admin/find-all";
      if (statusFilter) {
        url += `?status=${statusFilter}`;
      }
      const res = await getWithTokenAPI(token, url);
      if (res.statusCode === 200) {
        const mappedAdmins = (res.data.admin_list || []).map((admin) => ({
          ...(admin || {}),
          phone_no: admin?.phone_number || "",
          profile_image: admin?.profile_image || "",
        }));
        setAllAdmins(mappedAdmins);
      } else {
        toast.error(res.message || "Failed to load admins.");
        setAllAdmins([]);
      }
    } catch (error) {
      console.error("Fetch admins error:", error);
      toast.error("Failed to load admins due to a network error.");
      setAllAdmins([]);
    }
  }, []);

  const handleViewSoilTest = async (soilTest) => {
    const token = localStorage.getItem("token");
    setDialogLoading(true);
    setSelectedSoilTest(null);
    setOpenDialog(true);

    try {
      const res = await getWithTokenAPI(
        token,
        `/soil-testing/find-particular?_id=${soilTest._id}`
      );

      if (res.statusCode === 200) {
        setSelectedSoilTest(res.data);
      } else {
        toast.error(res.message || "Failed to load soil test details.");
        setOpenDialog(false);
      }
    } catch (error) {
      console.error("Fetch particular soil test error:", error);
      toast.error("Failed to load soil test details due to a network error.");
      setOpenDialog(false);
    } finally {
      setDialogLoading(false);
    }
  };

  const handleEditSoilTest = (soilTest) => {
    console.log(soilTest.croptype, "soilTest")
    setEditFormData({
      _id: soilTest._id,
      name: soilTest.name,
      total_amount: soilTest.total_amount,
      area: soilTest.area,
      soil_type: soilTest.soil_type,
      croptype: soilTest.croptype,
      Booking_status: soilTest.Booking_status,
      user_id: soilTest.user_id,
      address_id: soilTest.address_id,
      promo_id: soilTest.promo_id,
    });
    setOpenEditDialog(true);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdateSubmit = async () => {
    const token = localStorage.getItem("token");
    setIsUpdating(true);
    try {
      const payload = {
        _id: editFormData._id,
        name: editFormData.name,
        total_amount: parseFloat(editFormData.total_amount),
        area: parseFloat(editFormData.area),
        soil_type: editFormData.soil_type,
        croptype: editFormData.croptype,
        Booking_status: editFormData.Booking_status,
      };

      const res = await putAPI(token, "/soil-testing/update", payload);

      if (res.statusCode === 200) {
        toast.success(
          res.message || "Soil testing record updated successfully!"
        );
        setOpenEditDialog(false);
        fetchSoilTests();
      } else {
        toast.error(res.message || "Failed to update soil testing record.");
      }
    } catch (error) {
      console.error("Update soil test error:", error);
      toast.error("Failed to update record due to a network error.");
    } finally {
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    fetchSoilTests();
    fetchAdmins();
  }, [fetchSoilTests, fetchAdmins]);

  return (
    <Box sx={{ p: 3, width: "100%" }}>
      <ToastContainer position="top-center" autoClose={1500} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          p: 2,
          backgroundColor: lightGreen,
          borderRadius: 2,
          borderLeft: `5px solid ${primaryGreen}`,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ScienceIcon sx={{ color: primaryGreen, fontSize: 40, mr: 2 }} />
          <Box>
            <Typography
              variant="h4"
              component="h1"
              sx={{ color: primaryGreen, fontWeight: "bold" }}
            >
              Soil Testing
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Manage soil testing records
            </Typography>
          </Box>
        </Box>
      </Box>

      <div className="table-container border rounded">
        <div className="table-responsive">
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <CircularProgress style={{ color: "#DC3545" }} />
              <Typography sx={{ ml: 2, color: "#DC3545" }}>Loading soil tests...</Typography>
            </Box>
          ) : (
            <table className="table m-0 resource-head">
              <thead
                className="sticky-header fs-6"
                style={{ backgroundColor: lightGreen }}
              >
                <tr>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    S.No
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    User
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    Test Name
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    Total Amount(Ksh)
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    Payment Status
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    Booking Status
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    Date
                  </th>
                  <th
                    className="table-header"
                    style={{ color: secondaryTextColor, textAlign: "left" }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentSoilTests.length > 0 ? (
                  currentSoilTests.map((soilTest, index) => (
                    <tr key={soilTest._id}>
                      <td style={{ textAlign: "left" }}>
                        {indexOfFirstSoilTest + index + 1}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            variant="body2"
                            sx={{
                              color: primaryGreen,
                              textDecoration: 'none',
                              cursor: 'pointer',
                              fontWeight: 'bold',


                            }}
                            onClick={() => handleViewSoilTest(soilTest)}

                          >
                            {soilTest.user_id?.name || "N/A"}
                          </Typography>
                        </Box>
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {soilTest.name || "N/A"}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {soilTest.total_amount?.toFixed(2) || "0.00"}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <Chip
                          label={soilTest.payment_status || "Pending"}
                          size="small"
                          sx={{
                            backgroundColor:
                              soilTest.payment_status === "Completed"
                                ? lightGreen
                                : "#fff3e0",
                            color:
                              soilTest.payment_status === "Completed"
                                ? darkGreen
                                : "#e65100",
                          }}
                        />
                      </td>
                      <td style={{ textAlign: "left" }}>
                        <Chip
                          label={soilTest.Booking_status || "Pending"}
                          size="small"
                          sx={{
                            backgroundColor:
                              soilTest.Booking_status === "Completed"
                                ? lightGreen
                                : soilTest.Booking_status === "Cancelled"
                                  ? "#ffebee"
                                  : "#fff8e1",
                            color:
                              soilTest.Booking_status === "Completed"
                                ? darkGreen
                                : soilTest.Booking_status === "Cancelled"
                                  ? "#c62828"
                                  : "#ff8f00",
                          }}
                        />
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {formatDate(soilTest.createdAt)}
                      </td>
                      <td style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                        <IconButton
                          onClick={() => handleViewSoilTest(soilTest)}
                          sx={{ color: primaryGreen }}
                          aria-label="view"
                        >
                          <VisibilityIcon />
                        </IconButton>
                        {
                          permissions.includes("update_soiltest") && (
                            <IconButton
                              onClick={() => handleEditSoilTest(soilTest)}
                              sx={{ color: primaryGreen }}
                              aria-label="edit"
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <ScienceIcon
                        sx={{ fontSize: 60, color: "text.disabled", mb: 2 }}
                      />
                      <Typography variant="h6" sx={{ color: "text.disabled" }}>
                        No soil testing bookings found.
                      </Typography>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {totalPages > 1 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            mt: 3,
            pb: 2,
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="green"
            sx={{
              "& .MuiPaginationItem-root": {
                color: primaryGreen,
              },
              "& .MuiPaginationItem-root.Mui-selected": {
                backgroundColor: primaryGreen,
                color: "white",
              },
            }}
          />
        </Box>
      )}

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
      >
        {dialogLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 300,
              width: "100%",
            }}
          >
            <CircularProgress sx={{ color: primaryGreen }} />
            <Typography sx={{ ml: 2 }}>Loading details...</Typography>
          </Box>
        ) : selectedSoilTest ? (
          <>
            <DialogTitle
              sx={{
                backgroundColor: primaryGreen,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div className="d-flex align-items-center">
                <ScienceIcon sx={{ mr: 1 }} />
                <h5 className="modal-title"> Soil Test Details</h5>
              </div>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setOpenDialog(false)}
              ></button>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      border: `1px solid ${lightGreen}`,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        color: darkGreen,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <PersonIcon sx={{ mr: 1 }} />
                      User Information
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Avatar
                        src={selectedSoilTest.user_id?.profile_image}
                        sx={{
                          width: 60,
                          height: 60,
                          mr: 2,
                          bgcolor: primaryGreen,
                        }}
                      >
                        {selectedSoilTest.user_id?.name?.charAt(0) || "U"}
                      </Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {selectedSoilTest.user_id?.name || "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pl: 2 }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <EmailIcon sx={{ color: darkGreen, mr: 1 }} />
                        <Typography variant="body2">
                          {selectedSoilTest.user_id?.email || "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <PhoneIcon sx={{ color: darkGreen, mr: 1 }} />
                        <Typography variant="body2">
                          {selectedSoilTest.user_id?.phone_number || "N/A"}
                        </Typography>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                        <CiLocationOn  sx={{ color: darkGreen, mr: 1 }} />
                        <Typography variant="body2">
                          {selectedSoilTest?.address_id?.street || "N/A"}, {selectedSoilTest?.address_id?.city || ""}, {selectedSoilTest?.address_id?.state || ""}, {selectedSoilTest?.address_id?.country || ""} - {selectedSoilTest?.address_id?.zip_code || ""}
                        </Typography>
                      </Box>

                    </Box>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      border: `1px solid ${lightGreen}`,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        color: darkGreen,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ScienceIcon sx={{ mr: 1 }} />
                      Test Summary
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Test ID:</span>
                        <span style={{ fontWeight: "bold" }}>
                          {selectedSoilTest._id}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Test Name:</span>
                        <span>{selectedSoilTest.name || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Tax Amount:</span>
                        <span>{selectedSoilTest.tax_amount || "N/A"}</span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <span>Total Amount (Ksh):</span>
                        <span>{selectedSoilTest.total_amount || "N/A"}</span>
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenDialog(false)} sx={{ color: darkGreen, borderColor: darkGreen }}>
                Close
              </Button>
            </DialogActions>
          </>
        ) : (
          <Typography sx={{ p: 3, textAlign: "center" }}>
            No details available.
          </Typography>
        )}
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: primaryGreen,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 24px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ScienceIcon sx={{ mr: 1 }} />
            <Typography variant="h6">Edit Soil Test</Typography>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpenEditDialog(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Test Name"
                name="name"
                value={editFormData.name || ""}
                onChange={handleEditFormChange}
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Total Amount"
                name="total_amount"
                type="number"
                value={editFormData.total_amount || ""}
                onChange={handleEditFormChange}
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Area"
                name="area"
                type="number"
                value={editFormData.area || ""}
                onChange={handleEditFormChange}
                margin="normal"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="normal" variant="outlined">
                <InputLabel>Soil Type</InputLabel>
                <Select
                  name="soil_type"
                  value={editFormData.soil_type || ""}
                  onChange={handleEditFormChange}
                  label="Soil Type"
                  sx={{ px: 5 }}
                >
                  {soilTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="normal" variant="outlined">
                <InputLabel>Crop Type</InputLabel>
                <Select
                  name="croptype"
                  value={editFormData.croptype || ""}
                  onChange={handleEditFormChange}
                  label="Crop Type"
                  sx={{ px: 5 }}
                >
                  {cropTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="normal" variant="outlined">
                <InputLabel>Booking Status</InputLabel>
                <Select
                  name="Booking_status"
                  value={editFormData.Booking_status || ""}
                  onChange={handleEditFormChange}
                  label="Booking Status"
                  sx={{ px: 5 }}
                >
                  {bookingStatuses.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenEditDialog(false)}
            disabled={isUpdating}
            sx={{ color: darkGreen, borderColor: darkGreen }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateSubmit}
            sx={{ backgroundColor: primaryGreen, color: "white" }}
            disabled={isUpdating}
          >
            {isUpdating ? <CircularProgress size={24} /> : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SoilTesting;